
import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_HOST + '/api/gathering/'
})

export default axiosInstance
